import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'
// import snackbar from '../mixins/snackbar'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)){
    if (store.getters['auth/isLoggedIn']) {
      //auth ok : est-ce qu'il y a les droits ?
      if (to.meta.requiresPerm){
        if (store.state.auth.currentPerm[to.meta.requiresPerm] && store.state.auth.currentPerm[to.meta.requiresPerm].lecture){
          next();
          return
        } else {
          //permission pas ok
          next(false);
        }
      } else {
        //pas besoin de permission
        next();
        return
      }
      
    } else {
      //auth pas ok
      next('/');
    }
  } else {
    //pas besoin de auth
    next();
  }
});

export default router
